// extracted by mini-css-extract-plugin
module.exports = {"button":"EABDBackButton_button__gpF2e","text":"EABDBackButton_text__3KRvK","arrow":"EABDBackButton_arrow__3H9Q4"};